import {retry, retryMutation} from '@hconnect/common/query/queryMutationRetry'
import {useNotification} from '@hconnect/uikit'
import {QueryClient, QueryClientProvider} from '@tanstack/react-query'
import {ReactQueryDevtools} from '@tanstack/react-query-devtools'
import {AxiosError} from 'axios'
import React from 'react'

export const PlannerQueryClient = new QueryClient()

export const QueryProvider = ({children}: {children: React.ReactNode}) => {
  const {notify} = useNotification()

  // TODO use onError in QueryCache instead to handle errors only after a certain number of retries
  // right now it's called on every failed query/mutation
  const onError = (err: unknown) => {
    const axiosError = err as AxiosError<Record<string, string>>
    const response = axiosError.response
    const responseErrorData = response?.data
    if (!responseErrorData) {
      notify('error', axiosError.message)
    } else {
      const responseErrorMessage =
        typeof responseErrorData === 'string' ? responseErrorData : responseErrorData?.detail
      notify('error', responseErrorMessage ?? axiosError.message)
    }
  }

  PlannerQueryClient.getQueryCache().config.onError = onError

  PlannerQueryClient.setDefaultOptions({
    queries: {
      retry,
      refetchOnWindowFocus: false,
      staleTime: Infinity
    },
    mutations: {
      retry: retryMutation,
      onError
    }
  })

  return (
    <QueryClientProvider client={PlannerQueryClient}>
      {children}
      <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
    </QueryClientProvider>
  )
}
